import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import {
  selectCanAddProject,
  selectLoading,
  selectOnlyMine,
  selectProjectEntityList,
  selectSearchPhrase
} from '../../store/project-entity-list/project-entity-list.selectors';
import { ProjectEntityListActions } from '../../store/project-entity-list/project-entity-list.actions';
import { ProductContextActions } from '../../../project/store/product-context/product-context.actions';
import { selectIsAdmin } from 'src/app/auth/store/session/session.selectors';
import { Entity } from '../../../core/models/entity.model';

@Component({
  selector: 'app-project-list-view',
  templateUrl: './project-list-view.component.html',
  styleUrls: ['./project-list-view.component.scss'],
  standalone: false
})
export class ProjectListViewComponent implements OnInit {
  projectEntityList$: Observable<Entity[]>;
  loading$: Observable<boolean>;
  searchPhrase$: Observable<string>;
  onlyMine$: Observable<boolean>;
  isAdmin$: Observable<boolean>;
  breadcrumbs: Breadcrumb[];
  canAddProject$: Observable<boolean>;
  context$: Observable<string>;

  @ViewChild('fileInput') fileInput;

  constructor(private store: Store, private router: Router, private route: ActivatedRoute) {
    this.store.dispatch(ProductContextActions.set_context({ context: 'Projects' }));
    this.projectEntityList$ = this.store.select(selectProjectEntityList);
    this.loading$ = this.store.select(selectLoading);
    this.searchPhrase$ = this.store.select(selectSearchPhrase);
    this.onlyMine$ = this.store.select(selectOnlyMine);
    this.isAdmin$ = this.store.select(selectIsAdmin);
    this.breadcrumbs = [{ url: '/projects', text: 'UI.Common.Breadcrumb.Projects', translatable: true, isCurrent: true }];
    this.canAddProject$ = this.store.select(selectCanAddProject);
  }

  ngOnInit() {
    this.store.dispatch(ProjectEntityListActions.query_entity_list_start());
  }

  addProject() {
    this.router.navigate(['./new'], { relativeTo: this.route });
  }

  importFromXml(file) {
    if (file && file.files && file.files[0]) {
      this.store.dispatch(ProjectEntityListActions.import_xml_start({ file: file.files[0] }));
      /*
       * This makes it possible to import the same file twice one after another.
       * Otherwise, action is not working without any errors
       */
      this.fileInput.nativeElement.value = '';
    }
  }
}
